module.exports = __webpack_public_path__ + "static/media/DEATH_DANCE.15c20cea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DEATH_DANCE.png
// module id = 131
// module chunks = 0